import secureStorage from "../utils/SecureStorage";
import config from "../configs/config.app";
import moment from "moment-jalaali";
import has from "lodash/has";
import isNil from "lodash/isNil";
import { tools } from "../utils/tools";

moment.locale("fa");
moment.loadPersian();

const ServiceStorage = {
  setToken: (accessToken, refreshToken = null) => {
    secureStorage.setItem(config.accessToken, accessToken);
    secureStorage.setItem(config.refreshToken, refreshToken);

    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      localStorage.setItem(config.accessToken + "_DEV", accessToken);
      localStorage.setItem(config.refreshToken + "_DEV", refreshToken);
    }
  },
  setPromoCode: (PrC = null) => {

    secureStorage.setItem("LinkPromoCode", PrC);
    secureStorage.setItem("LinkPromoCodeDate", moment().format('jYYYY/jMM/jDD HH:mm:ss'));


    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      localStorage.setItem("LinkPromoCode_DEV", PrC);
      localStorage.setItem("LinkPromoCodeDate_DEV", moment().format('jYYYY/jMM/jDD HH:mm:ss'));
    }

  },
  setUserInfo: (userInfo) => {
    secureStorage.setItem(config.userInfo, userInfo);

    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      localStorage.setItem(config.userInfo + "_DEV", JSON.stringify(userInfo));
    }
  },
  getUserInfo: () => {
    return secureStorage.getItem(config.userInfo);
  },

  getAccessToken: () => {
    return secureStorage.getItem(config.accessToken);
  },
  getPromoCode: () => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      return localStorage.getItem("LinkPromoCode_DEV");
    } else
      return secureStorage.getItem("LinkPromoCode");
  },
  getPromoCodeDate: () => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      return localStorage.getItem("LinkPromoCodeDate_DEV");
    } else
      return secureStorage.getItem("LinkPromoCodeDate");
  },
  getRefreshToken: () => {
    return secureStorage.getItem(config.refreshToken);
  },
  removePromoCode() {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      localStorage.removeItem("LinkPromoCodeDate_DEV");
      localStorage.removeItem("LinkPromoCode_DEV");
    } else {
      secureStorage.removeItem("LinkPromoCodeDate_DEV");
      secureStorage.removeItem("LinkPromoCode_DEV");
    }
  },
  clearToken: () => {
    secureStorage.clear();
    localStorage.clear();
    // localStorage.clear(config.accessToken);
    // localStorage.clear(config.refreshToken);
  },
  setCity: (item) => {
    localStorage.setItem("city", JSON.stringify({ cityListLastUpdate: item.cityListLastUpdate, cityList: JSON.stringify(item.cityList), selectedCity: item.selectedCity }));
  },
  getCity: () => {
    return tools.jsonDecode(localStorage.getItem("city"));
  },
  getSelectedCity: () => {
    let city = tools.jsonDecode(localStorage.getItem("city"));
    if (!isNil(city) && has(city, "selectedCity") && !isNil(city?.selectedCity))
      return city?.selectedCity;
    else
      return null;
  },
  setSelectedCity: (selectedCity) => {
    let city = tools.jsonDecode(localStorage.getItem("city"));
    if (!isNil(city) && has(city, "selectedCity") && !isNil(city?.selectedCity)) {
      localStorage.setItem("city", JSON.stringify({ ...city, selectedCity: selectedCity }));
    }
  },
  checkRemovalV2: () => {
    if (localStorage.getItem("setV2") != "1") {
      localStorage.clear();
      localStorage.setItem("setV2", "1");
    }
    else {
    }
  }
};
export default ServiceStorage;
